import Api from "shared/service/api/api";
import {
  SET_MESSAGE_TYPES,
  SET_ORDER_STATES,
  SET_MANAGERS,
  SET_ITEM_DATA,
  SET_FINANCE_DATA,
  SET_USER_DATA,
  SET_COURSE_LESSON_TYPES,
} from "./project.store";

import store from "shared/store";

// actions
export const LOAD_COMMON = "loadCommon";

//mutations
export const SET_RECEIVER_SERVICE_INSTANCES = "setReceiverServiceInstances";
export const SET_BALANCE_TYPES = "setBalanceTypes";
export const SET_VERIFICATION_REQUEST_STATES = "setVerificationRequestStates";
export const SET_ADMIN_COMMON_LOADED = "setAdminCommonLoaded";

const state = {
  adminCommonLoaded: false,
  datasets: {
    receiverServiceInstances: [],
    balanceTypes: [],
    verificationRequestStates: [],
  },
};

const getters = {
  adminCommonLoaded: (state) => state.adminCommonLoaded,
  receiverServiceInstances: (state) => state.datasets.receiverServiceInstances,
  balanceTypes: (state) => state.datasets.balanceTypes,
  verificationRequestStates: (state) => state.datasets.verificationRequestStates,
};

const actions = {
  [LOAD_COMMON]({ commit }) {
    return Api.admin
      .common()
      .then((response) => {
        store.commit("project/" + SET_MESSAGE_TYPES, response.data.message_type);
        store.commit("project/" + SET_ORDER_STATES, response.data.order);
        store.commit("project/" + SET_MANAGERS, response.data.managers);
        store.commit("project/" + SET_ITEM_DATA, response.data.item);
        store.commit("project/" + SET_FINANCE_DATA, response.data.finance);
        store.commit("project/" + SET_USER_DATA, response.data.user);
        store.commit("project/" + SET_COURSE_LESSON_TYPES, response.data.course.lesson);
        commit(SET_RECEIVER_SERVICE_INSTANCES, response.data.receiver_service_instances);
        commit(SET_BALANCE_TYPES, response.data.balance_types);
        commit(SET_VERIFICATION_REQUEST_STATES, response.data.verification_request_states);
        commit(SET_ADMIN_COMMON_LOADED);

        return response;
      })
      .catch((e) => e);
  },
};

const mutations = {
  [SET_RECEIVER_SERVICE_INSTANCES](state, receiverServiceInstances) {
    state.datasets.receiverServiceInstances = receiverServiceInstances;
  },
  [SET_BALANCE_TYPES](state, balanceTypes) {
    state.datasets.balanceTypes = balanceTypes;
  },
  [SET_VERIFICATION_REQUEST_STATES](state, verificationRequestStates) {
    state.datasets.verificationRequestStates = verificationRequestStates;
  },
  [SET_ADMIN_COMMON_LOADED](state) {
    state.adminCommonLoaded = true;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
